import CardDesignerIDCardElementControls from './CardDesignerIDCardElementControls';
import CardDesignerIDCardElementControlsButton from './CardDesignerIDCardElementControlsButton';
export { CardDesignerIDCardElementControlsButton };
export default CardDesignerIDCardElementControls;
